export const GUESTBOOK_MESSAGES_PER_PAGE = 4;


// WEBPACK FOOTER //
// ./src/constants/profile.js